import { Card, Typography, Space, Button } from 'antd';
import { HistoryOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { formatDate } from '../../utils/dateUtils';

const { Text } = Typography;

const OwnershipCard = ({ candidate, onViewHistory }) => {
  const history = useHistory();

  const findActiveOwnership = () => {
    const today = new Date();
    for (const referral of candidate.referrals || []) {
      if (!referral.ownerships) continue;
      for (const ownership of referral.ownerships) {
        if (!ownership.isActive) continue;
        const startDate = new Date(ownership.startDate);
        const endDate = new Date(ownership.endDate);
        if (today >= startDate && today <= endDate) {
          return { ownership, referrer: referral.user };
        }
      }
    }
    return null;
  };

  const activeOwnership = findActiveOwnership();
  const hasAnyOwnerships = candidate.referrals?.some(r => r.ownerships?.length > 0);

  let ownershipStatus;
  if (activeOwnership) {
    ownershipStatus = 'current';
  } else if (hasAnyOwnerships) {
    ownershipStatus = 'expired';
  } else {
    ownershipStatus = 'never';
  }

  const getOwnershipDisplay = () => {
    switch (ownershipStatus) {
      case 'current':
        return {
          label: 'Active Referrer',
          content: activeOwnership?.referrer?.id ? (
            <a
              href={`/employees/${activeOwnership.referrer.id}`}
              onClick={(e) => {
                e.preventDefault();
                history.push(`/employees/${activeOwnership.referrer.id}`);
              }}
              style={{ display: 'block', fontSize: '16px', fontWeight: 'bold', color: '#1890ff', textDecoration: 'none' }}
            >
              {`${activeOwnership.referrer.firstName} ${activeOwnership.referrer.lastName}`}
            </a>
          ) : (
            <Text strong style={{ display: 'block', fontSize: '16px', color: '#1890ff' }}>
              {activeOwnership?.referrer ? `${activeOwnership.referrer.firstName} ${activeOwnership.referrer.lastName}` : 'Unknown'}
            </Text>
          ),
          showUntil: true
        };
      case 'expired':
        return {
          label: 'Referral Credit Status',
          content: (
            <Text style={{ display: 'block', fontSize: '14px', color: '#666', fontStyle: 'italic' }}>
              No current referral credit — previous credit has expired.
            </Text>
          ),
          showUntil: false
        };
      case 'never':
        return {
          label: 'Referral Credit Status',
          content: (
            <Text style={{ display: 'block', fontSize: '14px', color: '#666', fontStyle: 'italic' }}>
              Referral credit not established — candidate hasn't applied or responded.
            </Text>
          ),
          showUntil: false
        };
      default:
        return {
          label: 'Active Referrer',
          content: <Text>Unknown</Text>,
          showUntil: false
        };
    }
  };

  const { label, content, showUntil } = getOwnershipDisplay();
  
  return (
    <Card 
      size="small" 
      style={{ 
        display: 'inline-block',
        minWidth: '200px',
        backgroundColor: 'rgba(255,255,255,0.95)',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(255,255,255,0.2)',
        borderRadius: '16px',
        boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
      }}
      bodyStyle={{ padding: '16px' }}
    >
      <Space direction="vertical" size="small" style={{ width: '100%' }}>
        <div>
          <Text type="secondary" style={{ fontSize: '12px' }}>{label}</Text>
          {content}
        </div>
        {showUntil && (
          <div>
            <Text type="secondary" style={{ fontSize: '12px' }}>Until</Text>
            <Text style={{ display: 'block', fontSize: '13px', color: '#666', fontWeight: '500' }}>
              {formatDate(activeOwnership?.ownership?.endDate) || 'Not specified'}
            </Text>
          </div>
        )}
        {hasAnyOwnerships && (
          <Button 
            type="link" 
            size="small" 
            icon={<HistoryOutlined />}
            onClick={onViewHistory}
            style={{ padding: '0', height: 'auto', fontSize: '12px' }}
          >
            View Referral History
          </Button>
        )}
      </Space>
    </Card>
  );
};

export default OwnershipCard;